import React from 'react';
import { isNil } from 'lodash';

import { getCreatorFullName } from 'utils/personUtils';
import { CreatorUserModel } from 'api/backofficeApiClient';
import moment from 'moment/moment';

type Props = {
  label: string;
  creator?: CreatorUserModel | null;
  children?: React.ReactNode;
  createdDate?: Date;
};

const format = 'hh:mm A [UTC] MM/DD/YYYY';

export default function BasePageLabel(props: Props) {
  const { label, creator, children, createdDate } = props;

  return (
    <div className="title-line">
      <span className="title-line__text">{label}</span>

      <span className="title-line__line" />

      {!isNil(creator) && (
        <span className="title-line__created">
          <span>Created by: </span>
          {getCreatorFullName(creator?.fullName)}
          {!isNil(createdDate) && (
            <span> at {moment.utc(createdDate).format(format)}</span>
          )}
        </span>
      )}

      {children && <>{children}</>}
    </div>
  );
}
